import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {RELATIONS} from "../../../core/consts";

export class PartialGameRequestParams extends BaseApiRequestParams {
  url: String;
  games: Array<Number>;
  competitions: Array<Number>;
  competitors: Array<Number>;
  sports: Array<Number>;
  countries: Array<Number>;
  showOdds: Boolean;
  favoriteCompetitions: Array<Number>;
  competitionsLimit: Number;
  onlyMajorGames: Boolean;
  onlyLiveGames: Boolean;
  filterName: String;
  numberOfGames: Number;
  withLive: Boolean;
  withTop: Boolean;
  withSuggested: Boolean;
  blackListGames: Array<Number>;
  context: String;
  includeTopBettingOpportunity: Number;
  topBookmaker: Number;
  onlyOnTv: Boolean;
  feedBy: Number;
  roundKey: String;
  matchupId: String;

  constructor(
    gameIds: Array<Number> = [],
    competitionIds: Array<Number> = [],
    competitorIds: Array<Number> = [],
    sportIds: Array<Number> = [],
    countries: Array<Number> = [],
    startDate: String,
    endDate: String,
    filterName: String = '',
    url: String,
    showOdds: Boolean,
    favoriteCompetitions: Array<Number>,
    competitionsLimit: Number,
    onlyMajorGames: Boolean,
    onlyLiveGames: Boolean,
    numberOfGames: Number,
    withLive: Boolean,
    withTop: Boolean,
    withSuggested: Boolean,
    blackListGames: Array<Number>,
    context: String,
    includeTopBettingOpportunity: Number,
    topBookmaker: Number,
    onlyOnTv: Boolean,
    feedBy: Number,
    roundKey: String,
    matchupId: String
  ) {
    super('games/' + (filterName ? filterName + '/' : ''));

    this.filterName = filterName;
    this.url = url;
    this.games = gameIds;
    this.competitions = competitionIds;
    this.competitors = competitorIds;
    this.sports = sportIds;
    this.countries = countries;
    this.startDate = startDate;
    this.endDate = endDate;
    this.showOdds = showOdds;
    this.favoriteCompetitions = favoriteCompetitions;
    this.competitionsLimit = competitionsLimit;
    this.onlyMajorGames = onlyMajorGames;
    this.onlyLiveGames = onlyLiveGames;
    this.numberOfGames = numberOfGames;
    this.withLive = withLive;
    this.withTop = withTop;
    this.withSuggested = withSuggested;
    this.blackListGames = blackListGames;
    this.context = context;
    this.includeTopBettingOpportunity = includeTopBettingOpportunity;
    this.topBookmaker = topBookmaker;
    this.onlyOnTv = onlyOnTv;
    this.feedBy = feedBy;
    this.roundKey = roundKey;
    this.matchupId = matchupId;
  }

  get relation() {
    const relation: RELATIONS = this.gamesParam && this.competitorsParam ? RELATIONS.or : null;

    return relation ? `&relation=${relation}` : '';
  }

  get gamesParam() {
    return this.games && this.games.length > 0 ? `&games=${this.games.toString()}` : '';
  }

  get competitionsParam() {
    return this.competitions && this.competitions.length > 0 ? `&competitions=${this.competitions.toString()}` : '';
  }

  get competitorsParam() {
    return this.competitors && this.competitors.length > 0 ? `&competitors=${this.competitors.toString()}` : '';
  }

  get sportsParam() {
    return this.sports && this.sports.length > 0 ? `&sports=${this.sports.toString()}` : '';
  }

  get countriesParam() {
    return this.countries?.length > 0 ? `&countries=${this.countries.toString()}` : '';
  }

  get startDateParam() {
    return this.startDate ? `&startDate=${this.startDate}` : '';
  }

  get endDateParam() {
    return this.endDate ? `&endDate=${this.endDate}` : '';
  }

  get showOddsParam() {
    return this.showOdds ? `&showOdds=${this.showOdds}` : '';
  }

  get onlyMajorGamesParam() {
    return this.onlyMajorGames ? `&onlyMajorGames=${this.onlyMajorGames}` : '';
  }

  get favoriteCompetitionsParam() {
    return this.favoriteCompetitions && this.favoriteCompetitions.length > 0 ? `&favoriteCompetitions=${this.favoriteCompetitions}` : '';
  }

  get competitionsLimitParam() {
    const useParam: Boolean = this.competitionsLimit > 0 && !this.lastUpdateId;

    return useParam ? `&competitionsLimit=${this.competitionsLimit}` : '';
  }

  get onlyLiveGamesParam() {
    return this.onlyLiveGames ? `&onlyLiveGames=${this.onlyLiveGames}` : '';
  }

  get numberOfGamesParams() {
    return this.numberOfGames > 0 ? `&numberOfGames=${this.numberOfGames}` : ``;
  }

  get withLiveParam() {
    return this.withLive ? `&withLive=${this.withLive}` : ``;
  }

  get withTopParam() {
    return this.withTop ? `&withTop=${this.withTop}` : ``;
  }

  get withSuggestedParam() {
    return this.withSuggested ? `&withSuggested=${this.withSuggested}` : ``;
  }

  get blackListGamesParam() {
    return this.blackListGames && this.blackListGames.length > 0 ? `&blackListGames=${this.blackListGames.toString()}` : '';
  }

  get contextParam() {
    return this.context ? `&context=${this.context}` : ``;
  }

  get includeTopBettingOpportunityParam() {
    return this.includeTopBettingOpportunity ? `&includeTopBettingOpportunity=${this.includeTopBettingOpportunity}` : ``;
  }

  get topBookmakerParam() {
    return this.topBookmaker > 0 ? `&topBookmaker=${this.topBookmaker}` : ``;
  }

  get feedByParam() {
    return this.feedBy > 0 ? `&feedBy=${this.feedBy}` : ``;
  }

  get onlyOnTvParam() {
    return this.onlyOnTv ? `&onlyOnTv=${this.onlyOnTv}` : '';
  }

  get roundKeyParam() {
    return this.roundKey ? `&roundKey=${this.roundKey}` : ``;
  }

  get matchupIdParam() {
    return this.matchupId ? `&matchupId=${this.matchupId}` : ``;
  }

  toString(): string {
    return this.url ? (this.root + this.url) : (super.toString() + this.relation + this.gamesParam +
      this.competitionsParam + this.competitorsParam + this.sportsParam + this.countriesParam + this.startDateParam +
      this.endDateParam + this.showOddsParam + this.onlyMajorGamesParam + this.favoriteCompetitionsParam +
      this.competitionsLimitParam + this.onlyLiveGamesParam + this.numberOfGamesParams + this.withLiveParam +
      this.withTopParam + this.withSuggestedParam + this.includeTopBettingOpportunityParam + this.blackListGamesParam +
      this.contextParam + this.topBookmakerParam + this.onlyOnTvParam + this.roundKeyParam + this.feedByParam + this.matchupIdParam);
  }

  equals(model: PartialGameRequestParams): * {
    let equals = super.equals(model);

    equals &= this.filterName === model.filterName;
    equals &= this.gamesParam === model.gamesParam;
    equals &= this.competitionsParam === model.competitionsParam;
    equals &= this.competitorsParam === model.competitorsParam;
    equals &= this.sportsParam === model.sportsParam;
    equals &= this.startDateParam === model.startDateParam;
    equals &= this.endDateParam === model.endDateParam;
    equals &= this.showOddsParam === model.showOddsParam;
    equals &= this.onlyMajorGamesParam === model.onlyMajorGamesParam;
    equals &= this.favoriteCompetitionsParam === model.favoriteCompetitionsParam;
    equals &= this.onlyLiveGamesParam === model.onlyLiveGamesParam;
    equals &= this.relation === model.relation;
    equals &= this.numberOfGamesParams === model.numberOfGamesParams;
    equals &= this.withTopParam === model.withTopParam;
    equals &= this.withLiveParam === model.withLiveParam;
    equals &= this.withTop === model.withTop;
    equals &= this.withSuggested === model.withSuggested;
    equals &= this.blackListGamesParam === model.blackListGamesParam;
    equals &= this.contextParam === model.contextParam;
    equals &= this.topBookmakerParam === model.topBookmakerParam;
    equals &= this.onlyOnTvParam === model.onlyOnTvParam;
    equals &= this.roundKeyParam === model.roundKeyParam;
    equals &= this.feedByParam === model.feedByParam;
    equals &= this.matchupIdParam === model.matchupIdParam;

    return equals;
  }
}
